module.exports = __webpack_public_path__ + "assets/img/ma-logo-98ca291b.png";